import { hasInErrorReason } from "./helpers.js";
class AccommodationSearch {
    constructor() {
        this.format = (response) => {
            const searchResultMetadata = {
                startIndex: response.searchResultMetaData?.startIndex,
                totalResults: response.searchResultMetaData?.totalResults,
                itemsPerPage: response.searchResultMetaData?.itemsPerPage,
                timeTaken: response.searchResultMetaData?.resultMetadata?.timeTaken,
                links: response.searchResultMetaData?.resultMetaData?._links,
            };
            const leaves = response.leaves || [];
            const LeaveSearch = leaves
                .filter((leave) => {
                return leave.employee &&
                    leave.leaveId?.includes("ACM") &&
                    !hasInErrorReason(leave.leaveCloseReason, leave.leaveCloseReasonDesc);
            })
                .flatMap((leave) => {
                const accommodationDetails = leave.accommodationDetails?.length
                    ? leave.accommodationDetails
                    : [
                        {
                            categoryDesc: "",
                            typeDesc: "",
                            decisionDesc: "",
                            decisionReasonDesc: "",
                            effectivenessDesc: "",
                            consideredDisabilityInd: "",
                            requiredInd: "",
                            beginDt: "",
                            endDt: "",
                        },
                    ];
                return accommodationDetails
                    .filter((accommodation) => !hasInErrorReason(accommodation?.decisionReasonDesc))
                    .map((accommodation) => {
                    const address = (leave.employee?.postalAddresses?.length ?? 0) > 0
                        ? leave.employee?.postalAddresses?.[0]
                        : {};
                    return {
                        fullName: leave.employee?.name,
                        employeeId: leave.employee?.employeeId,
                        workState: leave.employee?.employeeWorkStateCd,
                        jobTitle: leave.employee?.jobTitle,
                        leaveCloseReason: leave.leaveCloseReason,
                        categoryDesc: accommodation.categoryDesc,
                        beginDt: accommodation.beginDt,
                        endDt: accommodation.endDt,
                        typeDesc: accommodation.typeDesc,
                        decisionDesc: accommodation.decisionDesc,
                        decisionReasonDesc: accommodation.decisionReasonDesc,
                        effectivenessDesc: accommodation.effectivenessDesc,
                        consideredDisabilityInd: accommodation.consideredDisabilityInd,
                        requiredInd: accommodation.requiredInd,
                        firstName: leave.employee?.firstName,
                        lastName: leave.employee?.lastName,
                        accommodationStatus: leave.leaveStatus,
                        leaveId: leave.leaveId,
                        reportGroupName: leave.leavePeriod?.[0]?.reportGroupName ?? null,
                        reportGroupNumber: leave.leavePeriod?.[0]?.reportGroupNumber ?? null,
                        employerReportGroupNumber: leave.leavePeriod?.[0]?.employerReportGroupNumber ?? null,
                        reportedDt: leave.leaveRequestDt,
                        pregnancyRelatedInd: leave.pregnancyRelatedInd,
                        employerLocationName: leave.employee?.employerLocationName,
                        statusEffectiveDt: leave.leaveStatusEffectiveDt,
                        addressLineOne: address?.addressLineOne || null,
                        addressLineTwo: address?.addressLineTwo || null,
                        city: address?.city || null,
                        jurisdictionCode: address?.jurisdictionCode || null,
                        postalCode: address?.postalCode || null,
                        leaveSubmitMethod: leave.leaveSubmissionSource,
                        hireDt: leave.employee?.hireDt ?? null,
                        dateOfBirth: leave.employee?.dateOfBirth ?? null,
                        genderAtBirth: leave.employee?.genderAtBirth ?? null,
                        leaveRequestDt: leave.leaveRequestDt ?? null,
                    };
                });
            });
            return { searchResultMetadata, LeaveSearch };
        };
    }
}
export default new AccommodationSearch();
